document.addEventListener('DOMContentLoaded', (() => {
    (function () {
        if (!window.location.pathname.includes('/collections/')) {
            return;
        }

        const fetchAllBestSellers = async () => {
            const bestSellerIds = new Set();
            let page = 1;
            let hasMore = true;

            while (hasMore) {
                try {
                    const response = await fetch(`/collections/best-sellers/products.json?limit=250&page=${page}`);
                    const data = await response.json();

                    if (data.products && data.products.length > 0) {
                        data.products.forEach(p => bestSellerIds.add(String(p.id)));
                        page++;
                        if (data.products.length < 250) {
                            hasMore = false;
                        }
                    } else {
                        hasMore = false;
                    }
                } catch (error) {
                    console.error('Error fetching best-sellers page:', page, error);
                    hasMore = false;
                }
            }

            return bestSellerIds;
        };

        fetchAllBestSellers()
            .then(bestSellerIds => {
                const addBestsellerBadges = () => {
                    const productCards = document.querySelectorAll('.card-wrapper.product-card-wrapper');

                    productCards.forEach(card => {
                        let productId = null;

                        const productInfo = card.querySelector('[id^="ProductInfo-"]');
                        if (productInfo) {
                            const idParts = productInfo.id.split('-');
                            productId = idParts[idParts.length - 1];
                        }

                        if (productId && bestSellerIds.has(productId)) {
                            const existingBadge = card.querySelector('.best-seller-badge');
                            if (!existingBadge) {
                                const badge = document.createElement('div');
                                badge.classList.add('best-seller-badge');
                                badge.innerHTML = '<p>' + (window.bestsellerBadgeText || 'Bestseller') + '</p>';
                                card.insertBefore(badge, card.firstChild);
                            }
                        }
                    });
                };

                addBestsellerBadges();

                setTimeout(addBestsellerBadges, 500);

                const productGrid = document.querySelector('#gf-products') || document.querySelector('#product-grid');
                if (productGrid) {
                    const observer = new MutationObserver(() => {
                        addBestsellerBadges();
                    });

                    observer.observe(productGrid, {
                        childList: true,
                        subtree: true
                    });
                }

                document.addEventListener('click', (e) => {
                    if (e.target.closest('.pagination') || e.target.closest('[data-page]') || e.target.closest('a[href*="page="]')) {
                        setTimeout(addBestsellerBadges, 300);
                        setTimeout(addBestsellerBadges, 800);
                        setTimeout(addBestsellerBadges, 1500);
                    }
                });
            })
            .catch(error => {
                console.error('Error fetching best-sellers collection:', error);
            });
    })();

}))